import React, { useState, useRef, useEffect } from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import Icon from '../AppIcon';

const LANGUAGES = [
  { code: 'en', label: 'English', flag: 'EN' },
  { code: 'fr', label: 'Français', flag: 'FR' },
  { code: 'ar', label: 'العربية', flag: 'AR' },
];

const LanguageSwitcher = () => {
  const { locale, setLocale } = useLocale();
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Reposition dropdown if it overflows the viewport
  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      if (rect.right > window.innerWidth) {
        dropdownRef.current.style.right = 'auto';
        dropdownRef.current.style.left = `-${rect.right - window.innerWidth + 8}px`;
      }
      if (rect.left < 0) {
        dropdownRef.current.style.left = 'auto';
        dropdownRef.current.style.right = `-${Math.abs(rect.left) + 8}px`;
      }
    }
  }, [isOpen]);

  const currentLang = LANGUAGES.find(l => l.code === locale) || LANGUAGES[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-1.5 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors flex items-center gap-1"
        title="Change language"
      >
        <Icon name="Globe" size={16} />
        <span className="text-xs font-medium hidden sm:inline">{currentLang.flag}</span>
      </button>
      {isOpen && (
        <div
          ref={dropdownRef}
          className="absolute top-full end-0 mt-1 w-36 bg-card border border-border rounded-md shadow-elevation-3 py-1 z-dropdown"
        >
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => { setLocale(lang.code); setIsOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-sm transition-colors ${
                locale === lang.code ? 'bg-primary/5 text-primary font-medium' : 'text-foreground hover:bg-muted'
              }`}
            >
              <span className="text-xs font-semibold w-6">{lang.flag}</span>
              {lang.label}
              {locale === lang.code && <Icon name="Check" size={14} className="ltr:ml-auto rtl:mr-auto" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
